import { TagRecord, TTagToggleAction } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function postTagAnAppointmentForBusiness({
  aid,
  business_id,
  tagId,
}: {
  aid: string;
  business_id: string;
  tagId: TagRecord["tag_id"];
}): Promise<TrystGenericResponse<{ toggleAction: TTagToggleAction }>> {
  const TRYST_HOST = GET_TRYST_HOST();

  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    body: JSON.stringify({
      tagId,
    }),
    headers,
    credentials: "include",
  };

  const response = await fetch(
    `${TRYST_HOST}/business/${business_id}/appointment/${aid}/toggle-tag`,
    requestOptions
  );

  const postTagAnAppointmentForBusinessResponse: TrystGenericResponse<{
    toggleAction: TTagToggleAction;
  }> = await response.json();

  const { success, error } = postTagAnAppointmentForBusinessResponse;

  if (!success) {
    throw new Error(
      error || "Failed to complete the tag process for the appointment."
    );
  }

  return postTagAnAppointmentForBusinessResponse;
}
